import { defineStore } from 'pinia';

import type { Country } from '@/composables/countryList';

export const useLoginStore = defineStore('login', {
  state() {
    return {
      triggerCount: 0 as number,
      modal: '' as string,
      forceStart: false as boolean | 'ALWAYS',
      country: null as [Country, Country] | null,
      urlParsed: false as boolean | 'IS_LOGIN',
      loggedIn: false,
      modalOpen: false,
    };
  },
  actions: {
    triggerLogin(
      args: { modal?: string; forceLoginOnStart?: boolean; country?: [Country, Country] } = {},
    ) {
      this.triggerCount += 1;
      this.resetLogin(args);
    },
    resetLogin(
      args: { modal?: string; forceLoginOnStart?: boolean; country?: [Country, Country] } = {},
    ) {
      const { modal = '', forceLoginOnStart = false, country } = args;
      this.modal = modal;
      if (this.forceStart !== 'ALWAYS') {
        this.forceStart = forceLoginOnStart;
      }
      if (country) {
        this.country = country;
      }
    },
  },
});
